module.exports = __webpack_public_path__ + "img/ntk_nav_right_w.55434a8a.svg";